import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PageShell, PageHero, PageSection } from "../components/PageShell";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { adminService } from "../services/adminService";
import FormModal from "../components/FormModal";

export default function SuperAdminServerLogsPage() {
  const [items, setItems] = useState([]);
  const [error, setError] = useState("");
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    (async () => {
      const res = await adminService.listServerLogs();
      if (!res.ok) return setError(res.error || "Failed to fetch server logs");
      setItems(res.data?.items || []);
    })();
  }, []);

  return (
    <PageShell>
      <PageHero eyebrow="Super Admin" title="Server" highlight="logs." description="Critical backend and terminal/runtime errors with actor context." />
      <PageSection variant="content">
        <div className="mx-auto max-w-7xl grid gap-6">
          <div className="flex gap-2"><Link to="/super-admin" className="px-4 py-2 rounded-full border border-border text-sm">Back to Super Admin</Link></div>
          {error ? <Card><CardContent className="py-4 text-sm text-destructive">{error}</CardContent></Card> : null}
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {items.map((log) => (
              <Card key={log._id} className="cursor-pointer hover:-translate-y-0.5 transition-all" onClick={() => setSelected(log)}>
                <CardHeader><CardTitle className="text-base">{log.type || "server_error"}</CardTitle></CardHeader>
                <CardContent className="text-xs text-muted-foreground grid gap-1">
                  <div className="line-clamp-2">{log.message}</div>
                  <div>{log.logSource === "device" ? `Device: ${log.deviceId || log.actor?.name || "-"}` : `User: ${log.actor?.name || log.actor?.email || log.actorUid || "-"}`}</div>
                  <div>{log.method || "-"} {log.path || "-"}</div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </PageSection>
      <FormModal open={Boolean(selected)} title="Server Log Details" onClose={() => setSelected(null)}>
        <div className="grid gap-2 text-sm">
          <div><b>Type:</b> {selected?.type || "-"}</div>
          <div><b>Level:</b> {selected?.level || "-"}</div>
          <div><b>User:</b> {selected?.actor?.name || "-"} ({selected?.actor?.email || "-"})</div>
          <div><b>UID:</b> {selected?.actor?.uid || selected?.actorUid || "-"}</div>
          <div><b>Path:</b> {selected?.method || "-"} {selected?.path || "-"}</div>
          <div><b>Reason:</b> {selected?.reason || "-"}</div>
          <div><b>Error:</b> {selected?.message || "-"}</div>
          <div className="max-h-56 overflow-auto whitespace-pre-wrap rounded-xl border border-border p-3 bg-background">
            {selected?.stack || "No stack trace captured."}
          </div>
        </div>
      </FormModal>
    </PageShell>
  );
}

